import { useUniqId } from '../../libs/uniq-id';
export function useLabel(props) {
    var labelId = useUniqId();
    var fieldId = useUniqId(props.id);
    return {
        labelProps: {
            id: labelId,
            htmlFor: props.behavior === 'label' ? fieldId : undefined,
        },
        fieldProps: {
            'aria-labelledby': labelId,
            id: fieldId,
        },
    };
}
